export default {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGIN_CLEARERROR: 'LOGIN_CLEARERROR',
  SESSION_LOGIN: 'SESSION_LOGIN',
  SESSION_LOGOUT: 'SESSION_LOGOUT',

  ADAPTIVE_MATCHING_GET_CONFIGURATIONS_REQUEST:
    'ADAPTIVE_MATCHING_GET_CONFIGURATIONS_REQUEST',
  ADAPTIVE_MATCHING_GET_CONFIGURATIONS_SUCCESS:
    'ADAPTIVE_MATCHING_GET_CONFIGURATIONS_SUCCESS',
  ADAPTIVE_MATCHING_GET_CONFIGURATIONS_FAILURE:
    'ADAPTIVE_MATCHING_GET_CONFIGURATIONS_FAILURE',

  ADAPTIVE_MATCHING_SAVE_CONFIGURATION_REQUEST:
    'ADAPTIVE_MATCHING_SAVE_CONFIGURATION_REQUEST',
  ADAPTIVE_MATCHING_SAVE_CONFIGURATION_SUCCESS:
    'ADAPTIVE_MATCHING_SAVE_CONFIGURATION_SUCCESS',
  ADAPTIVE_MATCHING_SAVE_CONFIGURATION_FAILURE:
    'ADAPTIVE_MATCHING_SAVE_CONFIGURATION_FAILURE',

  ADAPTIVE_MATCHING_DELETE_CONFIGURATION_REQUEST:
    'ADAPTIVE_MATCHING_DELETE_CONFIGURATION_REQUEST',
  ADAPTIVE_MATCHING_DELETE_CONFIGURATION_SUCCESS:
    'ADAPTIVE_MATCHING_DELETE_CONFIGURATION_SUCCESS',
  ADAPTIVE_MATCHING_DELETE_CONFIGURATION_FAILURE:
    'ADAPTIVE_MATCHING_DELETE_CONFIGURATION_FAILURE',

  ADAPTIVE_MATCHING_REGENERATE_CONFIGURATION_REQUEST:
    'ADAPTIVE_MATCHING_REGENERATE_CONFIGURATION_REQUEST',
  ADAPTIVE_MATCHING_REGENERATE_CONFIGURATION_SUCCESS:
    'ADAPTIVE_MATCHING_REGENERATE_CONFIGURATION_SUCCESS',
  ADAPTIVE_MATCHING_REGENERATE_CONFIGURATION_FAILURE:
    'ADAPTIVE_MATCHING_REGENERATE_CONFIGURATION_FAILURE',

  ADMINCONFIG_CLEAR_ERROR: 'ADMIN_CONFIG_CLEAR_ERROR',
  ADMINCONFIG_GET_SUCCESS: 'ADMIN_CONFIG_GET_SUCCESS',
  ADMINCONFIG_GET_FAILURE: 'ADMIN_CONFIG_GET_FAILURE',
  ADMINCONFIG_SAVE_SUCCESS: 'ADMINCONFIG_SAVE_SUCCESS',
  ADMINCONFIG_SAVE_FAILURE: 'ADMINCONFIG_SAVE_FAILURE',

  AUDIT_EVENTS_CLEAR_ERROR: 'AUDIT_EVENTS_CLEAR_ERROR',
  AUDIT_EVENTTYPES_GET_REQUEST: 'AUDIT_EVENTTYPES_GET_REQUEST',
  AUDIT_EVENTTYPES_GET_SUCCESS: 'AUDIT_EVENTTYPES_GET_SUCCESS',
  AUDIT_EVENTTYPES_GET_FAILURE: 'AUDIT_EVENTTYPES_GET_FAILURE',
  AUDIT_EVENTS_GET_REQUEST: 'AUDIT_EVENTS_GET_REQUEST',
  AUDIT_EVENTS_GET_SUCCESS: 'AUDIT_EVENTS_GET_SUCCESS',
  AUDIT_EVENTS_GET_FAILURE: 'AUDIT_EVENTS_GET_FAILURE',

  BLOCKINGCONFIG_CLEAR_ERROR: 'BLOCKINGCONFIG_CLEAR_ERROR',
  BLOCKINGCONFIG_GET_REQUEST: 'BLOCKINGCONFIG_GET_REQUEST',
  BLOCKINGCONFIG_GET_SUCCESS: 'BLOCKINGCONFIG_GET_SUCCESS',
  BLOCKINGCONFIG_GET_FAILURE: 'BLOCKINGCONFIG_GET_FAILURE',
  BLOCKINGCONFIG_REINDEX_SUCCESS: 'BLOCKINGCONFIG_REINDEX_SUCCESS',
  BLOCKINGCONFIG_REINDEX_FAILURE: 'BLOCKINGCONFIG_REINDEX_FAILURE',
  BLOCKINGCONFIG_REPLACE_SUCCESS: 'BLOCKINGCONFIG_REPLACE_SUCCESS',
  BLOCKINGCONFIG_REPLACE_FAILURE: 'BLOCKINGCONFIG_REPLACE_FAILURE',
  BLOCKINGCONFIG_SAVE_REQUEST: 'BLOCKINGCONFIG_SAVE_REQUEST',
  BLOCKINGCONFIG_SAVE_SUCCESS: 'BLOCKINGCONFIG_SAVE_SUCCESS',
  BLOCKINGCONFIG_SAVE_FAILURE: 'BLOCKINGCONFIG_SAVE_FAILURE',

  CLUSTER_CLASSIFY_FAILURE: 'CLUSTER_CLASSIFY_FAILURE',
  CLUSTER_CLASSIFY_SUCCESS: 'CLUSTER_CLASSIFY_SUCCESS',
  CLUSTER_DELETELINK_FAILURE: 'CLUSTER_DELETELINK_FAILURE',
  CLUSTER_DELETELINK_SUCCESS: 'CLUSTER_DELETELINK_SUCCESS',
  CLUSTER_CLEAR_ERRORS: 'CLUSTER_CLEAR_ERRORS',
  CLUSTER_RECORDLINKS_FAILURE: 'CLUSTER_RECORDLINKS_FAILURE',
  CLUSTER_RECORDLINKS_REQUEST: 'CLUSTER_RECORDLINKS_REQUEST',
  CLUSTER_RECORDLINKS_SUCCESS: 'CLUSTER_RECORDLINKS_SUCCESS',

  CUSTOMFIELDS_ADD_SUCCESS: 'CUSTOMFIELDS_ADD_SUCCESS',
  CUSTOMFIELDS_CLEAR_ERROR: 'CUSTOMFIELDS_CLEAR_ERROR',
  CUSTOMFIELDS_DELETE_SUCCESS: 'CUSTOMFIELDS_DELETE_SUCCESS',
  CUSTOMFIELDS_DELETE_FAILURE: 'CUSTOMFIELDS_DELETE_FAILURE',
  CUSTOMFIELDS_GENERATE_SUCCESS: 'CUSTOMFIELDS_GENERATE_SUCCESS',
  CUSTOMFIELDS_GENERATE_FAILURE: 'CUSTOMFIELDS_GENERATE_FAILURE',
  CUSTOMFIELDS_GET_REQUEST: 'CUSTOMFIELDS_GET_REQUEST',
  CUSTOMFIELDS_GET_SUCCESS: 'CUSTOMFIELDS_GET_SUCCESS',
  CUSTOMFIELDS_GET_FAILURE: 'CUSTOMFIELDS_GET_FAILURE',
  CUSTOMFIELDS_REPLACE_SUCCESS: 'CUSTOMFIELDS_REPLACE_SUCCESS',
  CUSTOMFIELDS_REPLACE_FAILURE: 'CUSTOMFIELDS_REPLACE_FAILURE',
  CUSTOMFIELDS_SAVE_REQUEST: 'CUSTOMFIELDS_SAVE_REQUEST',
  CUSTOMFIELDS_SAVE_SUCCESS: 'CUSTOMFIELDS_SAVE_SUCCESS',
  CUSTOMFIELDS_SAVE_FAILURE: 'CUSTOMFIELDS_SAVE_FAILURE',

  CUSTOMMETRICS_CLEAR_ERROR: 'CUSTOMMETRICS_CLEAR_ERROR',
  CUSTOMMETRICS_DELETE_FAILURE: 'CUSTOMMETRICS_DELETE_FAILURE',
  CUSTOMMETRICS_GET_REQUEST: 'CUSTOMMETRICS_GET_REQUEST',
  CUSTOMMETRICS_GET_SUCCESS: 'CUSTOMMETRICS_GET_SUCCESS',
  CUSTOMMETRICS_GET_FAILURE: 'CUSTOMMETRICS_GET_FAILURE',
  CUSTOMMETRICS_LABEL_FAILURE: 'CUSTOMMETRICS_LABEL_FAILURE',
  CUSTOMMETRICS_LABEL_SUCCESS: 'CUSTOMMETRICS_LABEL_SUCCESS',
  CUSTOMMETRICS_NOT_FOUND: 'CUSTOMMETRICS_NOT_FOUND',
  CUSTOMMETRICS_SAVE_FAILURE: 'CUSTOMMETRICS_SAVE_FAILURE',
  CUSTOMMETRICS_SAVE_REQUEST: 'CUSTOMMETRICS_SAVE_REQUEST',
  CUSTOMMETRICS_SAVE_SUCCESS: 'CUSTOMMETRICS_SAVE_SUCCESS',

  DATAPROFILE_CLEAR_ERROR: 'DATAPROFILE_CLEAR_ERROR',
  DATAPROFILE_GENERATE_FAILURE: 'DATAPROFILE_GENERATE_FAILURE',
  DATAPROFILE_GENERATE_SUCCESS: 'DATAPROFILE_GENERATE_SUCCESS',
  DATAPROFILE_GET_FAILURE: 'DATAPROFILE_GET_FAILURE',
  DATAPROFILE_GET_REQUEST: 'DATAPROFILE_GET_REQUEST',
  DATAPROFILE_GET_SUCCESS: 'DATAPROFILE_GET_SUCCESS',
  DATAPROFILE_GETATTR_FAILURE: 'DATAPROFILE_GETATTR_FAILURE',
  DATAPROFILE_GETATTR_REQUEST: 'DATAPROFILE_GETATTR_REQUEST',
  DATAPROFILE_GETATTR_SUCCESS: 'DATAPROFILE_GETATTR_SUCCESS',
  DATAPROFILE_GETATTRVAL_FAILURE: 'DATAPROFILE_GETATTRVAL_FAILURE',
  DATAPROFILE_GETATTRVAL_REQUEST: 'DATAPROFILE_GETATTRVAL_REQUEST',
  DATAPROFILE_GETATTRVAL_SUCCESS: 'DATAPROFILE_GETATTRVAL_SUCCESS',
  DATAPROFILE_DELETE_FAILURE: 'DATAPROFILE_DELETE_FAILURE',
  DATAPROFILE_DELETE_SUCCESS: 'DATAPROFILE_DELETE_SUCCESS',

  DETERMATCHCONFIG_CLEAR_ERROR: 'DETERMATCHCONFIG_CLEAR_ERROR',
  DETERMATCHCONFIG_GET_FAILURE: 'DETERMATCHCONFIG_GET_FAILURE',
  DETERMATCHCONFIG_GET_REQUEST: 'DETERMATCHCONFIG_GET_REQUEST',
  DETERMATCHCONFIG_GET_SUCCESS: 'DETERMATCHCONFIG_GET_SUCCESS',
  DETERMATCHCONFIG_SAVE_FAILURE: 'DETERMATCHCONFIG_SAVE_FAILURE',
  DETERMATCHCONFIG_SAVE_SUCCESS: 'DETERMATCHCONFIG_SAVE_SUCCESS',
  DETERMODEL_INIT_SUCCESS: 'DETERMODEL_INIT_SUCCESS',
  DETERMODEL_INIT_FAILURE: 'DETERMODEL_INIT_FAILURE',

  ENTITIES_GET_REQUEST: 'ENTITIES_GET_REQUEST',
  ENTITIES_ADD_SUCCESS: 'ENTITIES_ADD_SUCCESS',
  ENTITIES_ADD_FAILURE: 'ENTITIES_ADD_FAILURE',
  ENTITIES_DELETE_SUCCESS: 'ENTITIES_DELETE_SUCCESS',
  ENTITIES_DELETE_FAILURE: 'ENTITIES_DELETE_FAILURE',
  ENTITIES_IMPORT_SUCCESS: 'ENTITIES_IMPORT_SUCCESS',
  ENTITIES_IMPORT_FAILURE: 'ENTITIES_IMPORT_FAILURE',
  ENTITIES_GET_SUCCESS: 'ENTITIES_GET_SUCCESS',
  ENTITIES_GET_FAILURE: 'ENTITIES_GET_FAILURE',
  ENTITIES_REPLACE_MATCHING_SUCCESS: 'ENTITIES_REPLACE_MATCHING_SUCCESS',
  ENTITIES_REPLACE_MATCHING_FAILURE: 'ENTITIES_REPLACE_MATCHING_FAILURE',
  ENTITIES_SAVE_REQUEST: 'ENTITIES_SAVE_REQUEST',
  ENTITIES_SAVE_SUCCESS: 'ENTITIES_SAVE_SUCCESS',
  ENTITIES_SAVE_FAILURE: 'ENTITIES_SAVE_FAILURE',
  ENTITIES_CLEARERROR: 'ENTITIES_CLEARERROR',
  ENTITY_SELECT: 'ENTITY_SELECT',
  ENTITY_CONFIG_EXPORT_FAILURE: 'ENTITY_CONFIG_EXPORT_FAILURE',
  ENTITY_RECORDS_EXPORT_FAILURE: 'ENTITY_RECORDS_EXPORT_FAILURE',

  FIELDS_FIRST_ENTITY: 'FIELDS_FIRST_ENTITY',
  FIELDS_GET_CUSTOMFIELDS: 'FIELDS_GET_CUSTOMFIELDS',

  FIELDVALUEINDEXCLUSTERS_GET_REQUEST: 'FIELDVALUEINDEXCLUSTERS_GET_REQUEST',
  FIELDVALUEINDEXCLUSTERS_GET_SUCCESS: 'FIELDVALUEINDEXCLUSTERS_GET_SUCCESS',
  FIELDVALUEINDEXCLUSTERS_GET_FAILURE: 'FIELDVALUEINDEXCLUSTERS_GET_FAILURE',
  FIELDVALUEINDEX_GET_SUCCESS: 'FIELDVALUEINDEX_GET_SUCCESS',
  FIELDVALUEINDEX_GET_FAILURE: 'FIELDVALUEINDEX_GET_FAILURE',
  FIELDVALUEINDEXES_CLEAR_ERROR: 'FIELDVALUEINDEXES_CLEAR_ERROR',
  FIELDVALUEINDEXES_DELETE_FAILURE: 'FIELDVALUEINDEXES_DELETE_FAILURE',
  FIELDVALUEINDEXES_GET_REQUEST: 'FIELDVALUEINDEXES_GET_REQUEST',
  FIELDVALUEINDEXES_GET_SUCCESS: 'FIELDVALUEINDEXES_GET_SUCCESS',
  FIELDVALUEINDEXES_GET_FAILURE: 'FIELDVALUEINDEXES_GET_FAILURE',
  FIELDVALUEINDEXES_NOT_FOUND: 'FIELDVALUEINDEXES_NOT_FOUND',
  FIELDVALUEINDEXES_REGEN_FAILURE: 'FIELDVALUEINDEXES_REGEN_FAILURE',
  FIELDVALUEINDEXES_SAVE_SUCCESS: 'FIELDVALUEINDEXES_SAVE_SUCCESS',
  FIELDVALUEINDEXES_SAVE_FAILURE: 'FIELDVALUEINDEXES_SAVE_FAILURE',

  FINDBYATTRIBUTES_REQUEST: 'FINDBYATTRIBUTES_REQUEST',
  FINDBYATTRIBUTES_SUCCESS: 'FINDBYATTRIBUTES_SUCCESS',
  FINDBYATTRIBUTES_FAILURE: 'FINDBYATTRIBUTES_FAILURE',

  FINDBYIDENTIFIER_REQUEST: 'FINDBYIDENTIFIER_REQUEST',
  FINDBYIDENTIFIER_SUCCESS: 'FINDBYIDENTIFIER_SUCCESS',
  FINDBYIDENTIFIER_FAILURE: 'FINDBYIDENTIFIER_FAILURE',

  FINDBYRECORDIDS_REQUEST: 'FINDBYRECORDIDS_REQUEST',
  FINDBYRECORDIDS_SUCCESS: 'FINDBYRECORDIDS_SUCCESS',
  FINDBYRECORDIDS_FAILURE: 'FINDBYRECORDIDS_FAILURE',

  FIND_CLEAR_ATTRIBUTES: 'FIND_CLEAR_ATTRIBUTES',
  FIND_RECORDLINKS_FAILURE: 'FIND_RECORDLINKS_FAILURE',
  FIND_RECORDLINKS_REQUEST: 'FIND_RECORDLINKS_REQUEST',
  FIND_RECORDLINKS_SUCCESS: 'FIND_RECORDLINKS_SUCCESS',
  FIND_RECORDBYID_SUCCESS: 'FIND_RECORDBYID_SUCCESS',
  FIND_RECORDBYID_FAILURE: 'FIND_RECORDBYID_FAILURE',

  GLOBALIDCONFIG_CLEAR_ERROR: 'GLOBALIDCONFIG_CLEAR_ERROR',
  GLOBALIDCONFIG_GET_FAILURE: 'GLOBALIDCONFIG_GET_FAILURE',
  GLOBALIDCONFIG_GET_REQUEST: 'GLOBALIDCONFIG_GET_REQUEST',
  GLOBALIDCONFIG_GET_SUCCESS: 'GLOBALIDCONFIG_GET_SUCCESS',
  GLOBALIDCONFIG_SAVE_FAILURE: 'GLOBALIDCONFIG_SAVE_FAILURE',
  GLOBALIDCONFIG_SAVE_SUCCESS: 'GLOBALIDCONFIG_SAVE_SUCCESS',

  IDDOMAINS_ADD_SUCCESS: 'IDDOMAINS_ADD_SUCCESS',
  IDDOMAINS_CLEAR_ERROR: 'IDDOMAINS_CLEAR_ERROR',
  IDDOMAINS_DELETE_SUCCESS: 'IDDOMAINS_DELETE_SUCCESS',
  IDDOMAINS_DELETE_FAILURE: 'IDDOMAINS_DELETE_FAILURE',
  IDDOMAINS_GET_REQUEST: 'IDDOMAINS_GET_REQUEST',
  IDDOMAINS_GET_SUCCESS: 'IDDOMAINS_GET_SUCCESS',
  IDDOMAINS_GET_FAILURE: 'IDDOMAINS_GET_FAILURE',
  IDDOMAINS_SAVE_REQUEST: 'IDDOMAINS_SAVE_REQUEST',
  IDDOMAINS_SAVE_SUCCESS: 'IDDOMAINS_SAVE_SUCCESS',
  IDDOMAINS_SAVE_FAILURE: 'IDDOMAINS_SAVE_FAILURE',

  JOBENTRIES_CLEAR_ERROR: 'JOBENTRIES_CLEAR_ERROR',
  JOBENTRIES_DELETE_SUCCESS: 'JOBENTRIES_DELETE_SUCCESS',
  JOBENTRIES_DELETE_FAILURE: 'JOBENTRIES_DELETE_FAILURE',
  JOBENTRIES_GET_REQUEST: 'JOBENTRIES_GET_REQUEST',
  JOBENTRIES_GET_SUCCESS: 'JOBENTRIES_GET_SUCCESS',
  JOBENTRIES_GET_FAILURE: 'IDDOMAINS_GET_FAILURE',
  JOBENTRYEVENTLOGS_GET_SUCCESS: 'JOBENTRYEVENTLOGS_GET_SUCCESS',
  JOBENTRYEVENTLOGS_GET_FAILURE: 'JOBENTRYEVENTLOGS_GET_FAILURE',

  LOAD_RECORDHISTORYBYID_SUCCESS: 'LOAD_RECORDHISTORYBYID_SUCCESS',
  LOAD_RECORDHISTORYBYID_FAILURE: 'LOAD_RECORDHISTORYBYID_FAILURE',

  LOGGED_PAIRS_CLEAR_ERROR: 'LOGGED_PAIRS_CLEAR_ERROR',
  LOGGED_PAIRS_DELETE_SUCCESS: 'LOGGED_PAIRS_DELETE_SUCCESS',
  LOGGED_PAIRS_DELETE_FAILURE: 'LOGGED_PAIRS_DELETE_FAILURE',
  LOGGED_PAIRS_GET_REQUEST: 'LOGGED_PAIRS_GET_REQUEST',
  LOGGED_PAIRS_GET_SUCCESS: 'LOGGED_PAIRS_GET_SUCCESS',
  LOGGED_PAIRS_GET_FAILURE: 'LOGGED_PAIRS_GET_FAILURE',
  LOGGED_RECORDPAIR_GET_REQUEST: 'LOGGED_RECORDPAIR_GET_REQUEST',
  LOGGED_RECORDPAIR_GET_SUCCESS: 'LOGGED_RECORDPAIR_GET_SUCCESS',
  LOGGED_RECORDPAIR_GET_FAILURE: 'LOGGED_RECORDPAIR_GET_FAILURE',

  OPERATION_ASSIGN_GLOBALID_SUCCESS: 'OPERATION_ASSIGN_GLOBALID_SUCCESS',
  OPERATION_ASSIGN_GLOBALID_FAILURE: 'OPERATION_ASSIGN_GLOBALID_FAILURE',
  OPERATION_CREATE_ENTITYIDXS_FAILURE: 'OPERATION_CREATE_ENTITYIDXS_FAILURE',
  OPERATION_CREATE_ENTITYINDXS_SUCCESS: 'OPERATION_CREATE_ENTITYINDXS_SUCCESS',
  OPERATION_DROP_ENTITYINDXS_FAILURE: 'OPERATION_DROP_ENTITYINDXS_FAILURE',
  OPERATION_DROP_ENTITYINDXS_SUCCESS: 'OPERATION_DROP_ENTITYINDXS_SUCCESS',
  OPERATIONS_CLEAR_ERROR: 'OPERATIONS_CLEAR_ERROR',
  OPERATION_REMOVE_GLOBALID_SUCCESS: 'OPERATION_REMOVE_GLOBALID_SUCCESS',
  OPERATION_REMOVE_GLOBALID_FAILURE: 'OPERATION_REMOVE_GLOBALID_FAILURE',
  OPERATION_START_PIXPDQ_FAILURE: 'OPERATION_START_PIXPDQ_FAILURE',
  OPERATION_START_PIXPDQ_SUCCESS: 'OPERATION_START_PIXPDQ_SUCCESS',
  OPERATION_STOP_PIXPDQ_FAILURE: 'OPERATION_STOP_PIXPDQ_FAILURE',
  OPERATION_STOP_PIXPDQ_SUCCESS: 'OPERATION_STOP_PIXPDQ_SUCCESS',

  PERFORMANCEMETRICS_CLEAR_ERROR: 'PERFORMANCEMETRICS_CLEAR_ERROR',
  PERFORMANCEMETRICS_GET_SUCCESS: 'PERFORMANCEMETRICS_GET_SUCCESS',
  PERFORMANCEMETRICS_GET_FAILURE: 'PERFORMANCEMETRICS_GET_FAILURE',

  PERMISSIONS_ADD_SUCCESS: 'PERMISSIONS_ADD_SUCCESS',
  PERMISSIONS_CLEAR_ERROR: 'PERMISSIONS_CLEAR_ERROR',
  PERMISSIONS_DELETE_SUCCESS: 'PERMISSIONS_DELETE_SUCCESS',
  PERMISSIONS_DELETE_FAILURE: 'PERMISSIONS_DELETE_FAILURE',
  PERMISSIONS_GET_REQUEST: 'PERMISSIONS_GET_REQUEST',
  PERMISSIONS_GET_SUCCESS: 'PERMISSIONS_GET_SUCCESS',
  PERMISSIONS_GET_FAILURE: 'PERMISSIONS_GET_FAILURE',
  PERMISSIONS_SAVE_REQUEST: 'PERMISSIONS_SAVE_REQUEST',
  PERMISSIONS_SAVE_SUCCESS: 'PERMISSIONS_SAVE_SUCCESS',
  PERMISSIONS_SAVE_FAILURE: 'PERMISSIONS_SAVE_FAILURE',

  PROBLOGGEDPAIRCOUNTS_GET_SUCCESS: 'PROBLOGGEDPAIRCOUNTS_GET_SUCCESS',
  PROBLOGGEDPAIRCOUNTS_GET_FAILURE: 'PROBLOGGEDPAIRCOUNTS_GET_FAILURE',
  PROBMATCHCONFIG_CLASSIFYPAIR_SUCCESS: 'PROBMATCHCONFIG_CLASSIFYPAIR_SUCCESS',
  PROBMATCHCONFIG_CLASSIFYPAIR_FAILURE: 'PROBMATCHCONFIG_CLASSIFYPAIR_FAILURE',
  PROBMATCHCONFIG_CLEAR_ERROR: 'PROBMATCHCONFIG_CLEAR_ERROR',
  PROBMATCHCONFIG_CLEAR_EVALUATION: 'PROBMATCHCONFIG_CLEAR_EVALUATION',
  PROBMATCHCONFIG_GET_SUCCESS: 'PROBMATCHCONFIG_GET_SUCCESS',
  PROBMATCHCONFIG_GET_FAILURE: 'PROBMATCHCONFIG_GET_FAILURE',
  PROBMATCHCONFIG_GET_REQUEST: 'PROBMATCHCONFIG_GET_REQUEST',
  PROBMATCHCONFIG_REPLACE_FAILURE: 'PROBMATCHCONFIG_REPLACE_FAILURE',
  PROBMATCHCONFIG_REPLACE_SUCCESS: 'PROBMATCHCONFIG_REPLACE_SUCCESS',
  PROBMATCHCONFIG_SAVE_FAILURE: 'PROBMATCHCONFIG_SAVE_FAILURE',
  PROBMATCHCONFIG_SAVE_SUCCESS: 'PROBMATCHCONFIG_SAVE_SUCCESS',
  PROBMODEL_INIT_SUCCESS: 'PROBMODEL_INIT_SUCCESS',
  PROBMODEL_INIT_FAILURE: 'PROBMODEL_INIT_FAILURE',

  RECORD_CLEAR_ERROR: 'RECORD_CLEAR_ERROR',
  RECORD_DELETE_FAILURE: 'RECORD_DELETE_FAILURE',
  RECORD_DELETE_SUCCESS: 'RECORD_DELETE_SUCCESS',
  RECORD_UPDATE_FAILURE: 'RECORD_UPDATE_FAILURE',
  RECORD_UPDATE_SUCCESS: 'RECORD_UPDATE_SUCCESS',
  RECORD_GENLINKS_SUCCESS: 'RECORD_GENLINKS_SUCCESS',
  RECORD_GENLINKS_FAILURE: 'RECORD_GENLINKS_FAILURE',

  RECORD_LINKS_ADDRECORDLINK_SUCCESS: 'RECORD_LINKS_ADDRECORDLINK_SUCCESS',
  RECORD_LINKS_ADDRECORDLINK_FAILURE: 'RECORD_LINKS_ADDRECORDLINK_FAILURE',
  RECORD_LINKS_CLEAR_ERROR: 'RECORD_LINKS_CLEAR_ERROR',
  RECORD_LINKS_GET_REQUEST: 'RECORD_LINKS_GET_REQUEST',
  RECORD_LINKS_CLASSIFYMATCH_SUCCESS: 'RECORD_LINKS_CLASSIFYMATCH_SUCCESS',
  RECORD_LINKS_CLASSIFYMATCH_FAILURE: 'RECORD_LINKS_CLASSIFYMATCH_FAILURE',
  RECORD_LINKS_CLASSIFYNMATCH_SUCCESS: 'RECORD_LINKS_CLASSIFYNMATCH_SUCCESS',
  RECORD_LINKS_CLASSIFYNMATCH_FAILURE: 'RECORD_LINKS_CLASSIFYNMATCH_FAILURE',
  RECORD_LINKS_GET_SUCCESS: 'RECORD_LINKS_GET_SUCCESS',
  RECORD_LINKS_GET_FAILURE: 'RECORD_LINKS_GET_FAILURE',
  RECORD_LINKS_EVALPROBABLE_SUCCESS: 'RECORD_LINKS_EVALPROBABLE_SUCCESS',
  RECORD_LINKS_EVALPROBABLE_FAILURE: 'RECORD_LINKS_EVALPROBABLE_FAILURE',

  REPORTS_CLEAR_ERROR: 'REPORTS_CLEAR_ERROR',
  REPORTS_CREATEREQ_SUCCESS: 'REPORTS_CREATEREQ_SUCCESS',
  REPORTS_CREATEREQ_FAILURE: 'REPORTS_CREATEREQ_FAILURE',
  REPORTS_DELETE_SUCCESS: 'REPORTS_DELETE_SUCCESS',
  REPORTS_DELETE_FAILURE: 'REPORTS_DELETE_FAILURE',
  REPORTS_DOWNLOAD_FAILURE: 'REPORTS_DOWNLOAD_FAILURE',
  REPORTS_GET_REQUEST: 'REPORTS_GET_REQUEST',
  REPORTS_GET_SUCCESS: 'REPORTS_GET_SUCCESS',
  REPORTS_GET_FAILURE: 'REPORTS_GET_FAILURE',
  REPORTS_GETREQ_REQUEST: 'REPORTS_GETREQ_REQUEST',
  REPORTS_GETREQ_SUCCESS: 'REPORTS_GETREQ_SUCCESS',
  REPORTS_GETREQ_FAILURE: 'REPORTS_GETREQ_FAILURE',

  ROLES_ADD_SUCCESS: 'ROLES_ADD_SUCCESS',
  ROLES_CLEAR_ERROR: 'ROLES_CLEAR_ERROR',
  ROLES_DELETE_SUCCESS: 'ROLES_DELETE_SUCCESS',
  ROLES_DELETE_FAILURE: 'ROLES_DELETE_FAILURE',
  ROLES_GET_REQUEST: 'ROLES_GET_REQUEST',
  ROLES_GET_SUCCESS: 'ROLES_GET_SUCCESS',
  ROLES_GET_FAILURE: 'ROLES_GET_FAILURE',
  ROLES_SAVE_REQUEST: 'ROLES_SAVE_REQUEST',
  ROLES_SAVE_SUCCESS: 'ROLES_SAVE_SUCCESS',
  ROLES_SAVE_FAILURE: 'ROLES_SAVE_FAILURE',

  SCHEDULEDTASKS_CLEAR_ERROR: 'SCHEDULEDTASKS_CLEAR_ERROR',
  SCHEDULEDTASKS_GET_SUCCESS: 'SCHEDULEDTASKS_GET_SUCCESS',
  SCHEDULEDTASKS_GET_FAILURE: 'SCHEDULEDTASKS_GET_FAILURE',
  SCHEDULEDTASKS_SAVE_SUCCESS: 'SCHEDULEDTASKS_SAVE_SUCCESS',
  SCHEDULEDTASKS_SAVE_FAILURE: 'SCHEDULEDTASKS_SAVE_FAILURE',

  SINGLEBESTRECORD_CLEAR_ERROR: 'SINGLEBESTRECORD_CLEAR_ERROR',
  SINGLEBESTRECORD_GET_FAILURE: 'SINGLEBESTRECORD_GET_FAILURE',
  SINGLEBESTRECORD_GET_REQUEST: 'SINGLEBESTRECORD_GET_REQUEST',
  SINGLEBESTRECORD_GET_SUCCESS: 'SINGLEBESTRECORD_GET_SUCCESS',
  SINGLEBESTRECORD_SAVE_FAILURE: 'SINGLEBESTRECORD_SAVE_FAILURE',
  SINGLEBESTRECORD_SAVE_SUCCESS: 'SINGLEBESTRECORD_SAVE_SUCCESS',

  STRINGCOMPARATORS_GET_FAILURE: 'TRANSFORMFUNCTIONS_GET_FAILURE',
  STRINGCOMPARATORS_GET_SUCCESS: 'STRINGCOMPARATORS_GET_SUCCESS',

  SYSTEMCONFIG_GET_FAILURE: 'SYSTEMCONFIG_GET_FAILURE',
  SYSTEMCONFIG_GET_SUCCESS: 'SYSTEMCONFIG_GET_SUCCESS',

  TRANSFORMFUNCTIONS_GET_SUCCESS: 'TRANSFORMFUNCTIONS_GET_SUCCESS',
  TRANSFORMFUNCTIONS_GET_FAILURE: 'TRANSFORMFUNCTIONS_GET_FAILURE',

  USER_FILES_CLEARERROR: 'USER_FILES_CLEARERROR',
  USER_FILES_DELETE_REQUEST: 'USER_FILES_DELETE_REQUEST',
  USER_FILES_DELETE_SUCCESS: 'USER_FILES_DELETE_SUCCESS',
  USER_FILES_DELETE_FAILURE: 'USER_FILES_DELETE_FAILURE',
  USER_FILES_GET_REQUEST: 'USER_FILES_GET_REQUEST',
  USER_FILES_GET_SUCCESS: 'USER_FILES_GET_SUCCESS',
  USER_FILES_GET_FAILURE: 'USER_FILES_GET_FAILURE',
  USER_FILES_IMPORT_STARTED: 'USERS_IMPORT_STARTED',
  USER_FILES_UPDATE_FAILURE: 'USER_FILES_UPDATE_FAILURE',
  USER_FILES_UPDATE_SUCCESS: 'USER_FILES_UPDATE_SUCCESS',

  USER_GET_SUCCESS: 'USER_GET_SUCCESS',
  USER_GET_FAILURE: 'USER_GET_FAILURE',
  USERS_ADD_SUCCESS: 'USERS_ADD_SUCCESS',
  USERS_CLEAR_ERROR: 'USERS_CLEAR_ERROR',
  USERS_DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
  USERS_DELETE_FAILURE: 'USERS_DELETE_FAILURE',
  USERS_GET_REQUEST: 'USERS_GET_REQUEST',
  USERS_GET_SUCCESS: 'USERS_GET_SUCCESS',
  USERS_GET_FAILURE: 'USERS_GET_FAILURE',
  USERS_SAVE_REQUEST: 'USERS_SAVE_REQUEST',
  USERS_SAVE_SUCCESS: 'USERS_SAVE_SUCCESS',
  USERS_SAVE_LOCAL_SUCCESS: 'USERS_SAVE_LOCAL_SUCCESS',
  USERS_SAVE_FAILURE: 'USERS_SAVE_FAILURE',

  VALUEMERGEOPERATIONS_CLEAR_ERROR: 'VALUEMERGEOPERATIONS_CLEAR_ERROR',
  VALUEMERGEOPERATIONS_DELETE_FAILURE: 'VALUEMERGEOPERATIONS_DELETE_FAILURE',
  VALUEMERGEOPERATIONS_GET_REQUEST: 'VALUEMERGEOPERATIONS_GET_REQUEST',
  VALUEMERGEOPERATIONS_GET_SUCCESS: 'VALUEMERGEOPERATIONS_GET_SUCCESS',
  VALUEMERGEOPERATIONS_GET_FAILURE: 'VALUEMERGEOPERATIONS_GET_FAILURE',
  VALUEMERGEOPERATIONS_NOT_FOUND: 'VALUEMERGEOPERATIONS_NOT_FOUND',
  VALUEMERGEOPERATIONS_REVERSE_FAILURE: 'VALUEMERGEOPERATIONS_REVERSE_FAILURE',
  VALUEMERGEOPERATIONS_SAVE_SUCCESS: 'VALUEMERGEOPERATIONS_SAVE_SUCCESS',
  VALUEMERGEOPERATIONS_SAVE_FAILURE: 'VALUEMERGEOPERATIONS_SAVE_FAILURE'
};
